import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-skeleton-loader',
  templateUrl: './skeleton-loader.component.html',
  styleUrls: ['./skeleton-loader.component.scss']
})
export class SkeletonLoaderComponent implements OnInit {

  @Input() loaderType = '';
  @Input() loaderSize = '';
  dummyRow: any;
  constructor() { }

  ngOnInit(): void {
    switch (this.loaderSize) {
      case 'small':
        this.dummyRow = Array(8).fill(this.dummyRow).map((x, i) => i);
        break;
      case 'medium':
        this.dummyRow = Array(10).fill(this.dummyRow).map((x, i) => i);
        break;
      case 'large':
        this.dummyRow = Array(15).fill(this.dummyRow).map((x, i) => i);
        break;
    }
  }

}
